module.exports = __webpack_public_path__ + "img/cache-ecrou.d4d2f5b6.jpg";